/* Courier parent partners + their POCs — real v6 master via SUPPLY_DATA. */
import {SUPPLY_DATA} from './_v6Data'

export const DUMMY_PARTNERS = SUPPLY_DATA.partners
export const DUMMY_PARTNERS_BY_ID = DUMMY_PARTNERS.reduce((m, p) => {
  m[p.id] = p
  return m
}, {})
export const getPartner = (id) => DUMMY_PARTNERS_BY_ID[id]
